/* eslint-disable */

import { JsonRpcMessage } from './message';
import { DefaultChannel } from "./../core/channel";

export class JsonRpcChannel extends DefaultChannel<JsonRpcMessage> {
    async call<T = void>(message: JsonRpcMessage): Promise<T>;
    async call<T = void>(method: string, params: [] | {}): Promise<T>;
    async call<T = void>(m: JsonRpcMessage | string, params?: [] | {}) {
        const method_ = m instanceof JsonRpcMessage ? m.method : m;
        const params_ = m instanceof JsonRpcMessage ? m.params : params;

        return await window.jrpc.call(method_, params_) as T;
    }

    notify(message: JsonRpcMessage): void;
    notify(method: string, params: [] | {}): void;
    notify(m: JsonRpcMessage | string, params?: [] | {}) {
        const method_ = m instanceof JsonRpcMessage ? m.method : m;
        const params_ = m instanceof JsonRpcMessage ? m.params : params;

        window.jrpc.notification(method_, params_);
    }
}
